import axios from 'axios'
import Qs from 'qs'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import {API_DOMAIN} from '../../config/apiConfig'
console.log(API_DOMAIN)
// create an axios instance
const service = axios.create({
  baseURL: API_DOMAIN, // api 的 base_url
  headers: {'content-type': 'application/x-www-form-urlencoded'},
  timeout: 10000 // request timeout
})
axios.defaults.headers.common['Authorization'] = 'AUTH_TOKEN'

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (store.getters.loginToken) {
      // config.headers['token'] = getToken()
      if(config.data){
        console.log(config);
        config.data.token = getToken()
      }
     
    }
    config.data = Qs.stringify(config.data)
    // console.log(config.data)
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  error => {
    if (error.message.includes('timeout')) {
      Message({
        message: '连接超时！请重试。',
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js